function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { Button, IconButton, TableList, Tooltip, Typography, WithInfoIcon } from 'seagull';
import { TrashFill18 } from 'seagull/icons';
import { makeTestId, displayLineItemRate, getClientStatusTooltip, getVendorStatusTooltip } from "../ScheduledInvoice.utils";
import styles from "../ScheduledInvoice.module.scss";
import { LineItemType } from "../../../../../models/invoice-draft";
import { emptyCell } from "../../../../../constants";
import { Intent } from "../../../../../infra/access-control";
import { utils } from "../../../../../utils";
import { LineItemPendingApprovalReason } from "../../../../../types/api.model";
import TimeActivityTooltip from "../../../../../components/TimeActivityTooltip/TimeActivityTooltip";
import { QboIntegrationLineItemType } from "../../../../../models/integration/model";
import { SubLineItemRow } from "./SubLineItem";
import { useFeatureFlags } from "../../../../../hooks/useFeatureFlags";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export function CustomerLineItem(props) {
  const {
    onApprove
  } = props;
  const {
    pendingApprovalReason
  } = props.charge;
  const testid = makeTestId(props.charge);
  const action = pendingApprovalReason === LineItemPendingApprovalReason.AdHocCharge ? /*#__PURE__*/_jsx(Button, {
    skin: "primaryOutline",
    intent: Intent.ApproveCharge,
    size: "small",
    "data-testid": "".concat(testid, "-approve"),
    onClick: onApprove,
    children: "Approve"
  }) : null;
  return /*#__PURE__*/_jsx(LineItem, _objectSpread(_objectSpread({}, props), {}, {
    testid: testid,
    action: action,
    getStatusTooltip: getClientStatusTooltip
  }));
}
export function VendorLineItem(props) {
  const {
    onRemove
  } = props;
  const testid = makeTestId(props.charge);
  const action = /*#__PURE__*/_jsx(VendorLineItemAction, _objectSpread({
    testid: testid
  }, makeRemoveButtonProps(props.charge, onRemove)));
  return /*#__PURE__*/_jsx(LineItem, _objectSpread(_objectSpread({}, props), {}, {
    testid: testid,
    action: action,
    getStatusTooltip: getVendorStatusTooltip
  }));
}
const makeRemoveButtonProps = (charge, onRemove) => {
  const {
    type
  } = charge;
  let removeButton;
  switch (type) {
    case LineItemType.Credit:
      removeButton = {
        disabled: true,
        tooltip: 'Credit can be disabled from the Billing Control',
        dataIntent: 'credit',
        intent: undefined
      };
      break;
    case LineItemType.Automatic:
      removeButton = {
        disabled: true,
        tooltip: 'Automatic services can be paused from the Billing Control',
        dataIntent: 'ongoing-service',
        intent: undefined
      };
      break;
    case LineItemType.Manual:
    case LineItemType.AdHocCharge:
      removeButton = {
        disabled: false,
        tooltip: 'Remove from invoice',
        dataIntent: 'active',
        intent: Intent.RemoveCharge
      };
      break;
  }
  return _objectSpread(_objectSpread({}, removeButton), {}, {
    onClick: onRemove
  });
};
function LineItem(rowProps) {
  var _charge$integrations;
  const {
    charge,
    testid,
    addedLineItemId,
    action,
    getStatusTooltip
  } = rowProps;
  const {
    SERVICE_TEMPLATE_BUNDLE
  } = useFeatureFlags();
  const subLineItems = charge.subLineItems;
  const hasLineItems = SERVICE_TEMPLATE_BUNDLE && subLineItems && subLineItems.length > 0;
  const chargeQboIntegration = (_charge$integrations = charge.integrations) === null || _charge$integrations === void 0 ? void 0 : _charge$integrations.find(integration => integration.type === QboIntegrationLineItemType.QBO);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(TableList.Row, {
      "data-testid": testid,
      addPulse: charge.id === addedLineItemId,
      size: "small",
      disableMarginBottom: !!charge.note || hasLineItems,
      items: [{
        value: /*#__PURE__*/_jsx(Typography, {
          variant: "paragraph2",
          ellipsis: true,
          "data-testid": "".concat(testid, "-name"),
          children: charge.name
        })
      }, {
        value: charge.quantity ? /*#__PURE__*/_jsx(Typography, {
          variant: "paragraph2",
          "data-testid": "".concat(testid, "-quantity"),
          children: utils.formatNumberWithCommas(charge.quantity)
        }) : null
      }, {
        value: /*#__PURE__*/_jsx(Typography, {
          variant: "paragraph2",
          ellipsis: true,
          "data-testid": "".concat(testid, "-rate"),
          children: displayLineItemRate(charge.rate)
        })
      }, {
        value: /*#__PURE__*/_jsx(Typography, {
          variant: "paragraph2",
          "data-testid": "".concat(testid, "-discount"),
          children: charge.discount ? charge.discount.format() : ''
        })
      }, {
        value: /*#__PURE__*/_jsx(Typography, {
          variant: "paragraph2",
          "data-testid": "".concat(testid, "-total"),
          children: utils.formatDollarAmount(charge.totalAmount)
        })
      }, {
        value: charge.pendingApprovalReason && /*#__PURE__*/_jsx(WithInfoIcon, {
          info: getStatusTooltip(charge.pendingApprovalReason),
          children: /*#__PURE__*/_jsx(Typography, {
            variant: "paragraph2",
            "data-testid": "".concat(testid, "-status"),
            "data-intent": charge.pendingApprovalReason,
            children: "Requires approval"
          })
        })
      }, {
        value: /*#__PURE__*/_jsxs("div", {
          className: styles.actions,
          children: [chargeQboIntegration ? /*#__PURE__*/_jsx(TimeActivityTooltip, {
            timeActivity: chargeQboIntegration.value.timeActivity
          }) : null, action]
        })
      }]
    }), charge.note && /*#__PURE__*/_jsx(TableList.Row, {
      "data-testid": "".concat(testid, "-note"),
      addPulse: addedLineItemId === charge.id,
      className: styles.gapBottom,
      disableMarginBottom: !!subLineItems && SERVICE_TEMPLATE_BUNDLE,
      size: "fluid",
      items: [{
        value: /*#__PURE__*/_jsx(Typography, {
          variant: "paragraph2",
          skin: "secondary",
          breakWords: true,
          children: charge.note
        })
      }, emptyCell, emptyCell, emptyCell, emptyCell, emptyCell, emptyCell]
    }), subLineItems && SERVICE_TEMPLATE_BUNDLE && subLineItems.map((subLineItem, index) => /*#__PURE__*/_jsx(SubLineItemRow, {
      subLineItem: subLineItem,
      testid: "".concat(testid, "-sub-line-item-").concat(index),
      disableMarginBottom: index !== subLineItems.length - 1,
      quantity: charge.quantity
    }))]
  });
}
function VendorLineItemAction(props) {
  return /*#__PURE__*/_jsx("div", {
    className: styles.vendorAction,
    children: /*#__PURE__*/_jsx(IconButton, {
      noPadding: true,
      size: "small",
      skin: "primaryTransparent",
      disabled: props.disabled,
      "data-testid": "".concat(props.testid, "-remove"),
      "data-intent": props.dataIntent,
      intent: props.intent,
      onClick: props.onClick,
      children: /*#__PURE__*/_jsx(Tooltip, {
        placement: "top",
        title: props.tooltip,
        children: /*#__PURE__*/_jsx("span", {
          children: /*#__PURE__*/_jsx(TrashFill18, {})
        })
      })
    })
  });
}